export default {
  title: 'Nouveau menu',
  headers: {
    edit_time: 'Modifier les horaires',
  },
  labels: {
    select_all: 'Tout sélectionner',
  },
  fields: {
    name: {
      label: 'Nom',
      placeholder: 'Saisir le nom du menu',
    },
    sorting_order: {
      label: "Ordre d'affichage du menu",
      placeholder: "Saisir l'ordre d'affichage du menu",
    },
    has_separate_schedule: {
      label: "Diffère des horaires d'ouverture habituels",
    },
    selected_days: {
      label: 'Jours sélectionnés',
    },
    opening_time: {
      label: "Heure d'ouverture",
    },
    closing_time: {
      label: 'Heure de fermeture',
    },
  },
  buttons: {
    add_opening_time: "Ajouter un horaire d'ouverture",
    add: 'Ajouter',
    cancel: 'Annuler',
    save: 'Enregistrer',
    close: 'Fermer',
  },
  feedback: {
    missing_info: 'Informations manquantes',
  },
  toasts: {
    menu_got_created: 'Menu créé',
    menu_got_updated: 'Menu mis à jour',
  },
};
